/* Genera 3 tipos de menus: Se recibe un arreglo con el nombre de los menus */

import React, { useState } from "react";
//*componentes-utiles
import GeneraMenuVertical from "../../../componentes/generaMenuVertical/GeneraMenuVertical";

//*datos
import menuArch from "../../../datos/json/menu1.json";

//*componente
export default function Ejemplo() {
  let menu = menuArch;
  let pasoMenu = menu;

  const [lado, setLado] = useState("d");

  //aqui se modifica el json
  pasoMenu.map((opcion: any) => {
    opcion["activo"] = "f";
    return pasoMenu;
  });

  console.log(pasoMenu, "pasoMenu.....");
  //lado i=izquierda y d=derecha
  return (
    <>
      <div className="container container-Vista">
        <h1>Ejemplo de generación de un menu tipo AAIE</h1>
        <button
          type="button"
          className={lado === "d" ? "btn btn-succes" : "btn btn-primary"}
          onClick={() => setLado("i")}
        >
          Izquierda
        </button>
        <button
          type="button"
          className={lado === "i" ? "btn btn-succes" : "btn btn-primary"}
          onClick={() => setLado("d")}
        >
          Derecha
        </button>
        <div className="container-Componente" >
          <br/>
          <GeneraMenuVertical lado={lado} menu={pasoMenu} />
          <br/>
        </div>
      </div>
    </>
  );
}
